export const UNKNOWN_PLANNING_STATUS = 'Status unavailable';

export const normalizePlanningStatus = (value: unknown): string => {
  if (typeof value !== 'string') return UNKNOWN_PLANNING_STATUS;

  const normalized = value.trim();
  return normalized || UNKNOWN_PLANNING_STATUS;
};
